import { HealthcareService } from "fhir/r3"
import { useContext } from "react"
import { useAppointmentRequestQuery } from "../../../api/fetchAppointmentRequests"
import { AuthenticationContext } from "../../../context/AuthenticationContext"
import {
  getCancellationQuestionnaireReference,
  getRescheduleQuestionnaireReference,
} from "../../../fhirUtils/healthcareServiceUtils"
const CANCELLATION_IN_PROGRESS =
  "The hospital has your request to cancel this appointment. They will make the change in approximately 2 working days."
const RESCHEDULE_IN_PROGRESS =
  "The hospital has your request to reschedule this appointment. They will make the change in approximately 2 working days."

type AppointmentStatusMessageProps = {
  healthcareService: HealthcareService
  appointmentId: string
  appointmentStatus: string
}
export const AppointmentStatusMessage = ({
  healthcareService,
  appointmentId,
  appointmentStatus,
}: AppointmentStatusMessageProps) => {
  const { token } = useContext(AuthenticationContext)

  const appointmentRequestsQuery = useAppointmentRequestQuery({
    appointmentId,
    appointmentStatus,
    token,
  })

  if (appointmentStatus === "cancelled") {
    return <p className="statusMessage">This appointment was cancelled. You should not attend.</p>
  }

  if (appointmentRequestsQuery.data) {
    const rescheduleRequests = appointmentRequestsQuery.data ?? []
    const cancellationInProgress = rescheduleRequests.some(
      (request) => request.reference === getCancellationQuestionnaireReference(healthcareService),
    )
    if (cancellationInProgress) {
      return <p className="statusMessage">{CANCELLATION_IN_PROGRESS}</p>
    }

    const rescheduleInProgress = rescheduleRequests.some(
      (request) => request.reference === getRescheduleQuestionnaireReference(healthcareService),
    )
    if (rescheduleInProgress) {
      return <p className="statusMessage">{RESCHEDULE_IN_PROGRESS}</p>
    }
  }
  return null
}
